module.exports = __webpack_public_path__ + "8c73e7fdabde9e55615101fe89a7fdf0.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img8.png
// module id = 1327
// module chunks = 0